window.detailPage = function() {
    const shareLink = () => {
        window.setShareLinks();
    };

    return {
        init: function() {
            shareLink();
        }
    };
}();